import { cn } from '@/lib/cn'
import type { ChatMessage } from '@/lib/api'
import { Bot, User } from 'lucide-react'

interface MessageBubbleProps {
  message: ChatMessage
  streaming?: boolean
}

export function MessageBubble({ message, streaming }: MessageBubbleProps) {
  const isUser = message.role === 'user'

  return (
    <div className={cn('flex gap-3', isUser && 'flex-row-reverse')}>
      {/* Avatar */}
      <div className={cn(
        'w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5',
        isUser
          ? 'bg-[var(--oc-accent)]/20 border border-[var(--oc-accent)]/30'
          : 'bg-white/8 border border-white/15',
      )}>
        {isUser
          ? <User size={14} className="text-[var(--oc-accent-light)]" />
          : <Bot size={14} className="text-white/60" />
        }
      </div>

      {/* Content */}
      <div className={cn(
        'max-w-[80%] space-y-1',
        isUser && 'items-end',
      )}>
        <div className={cn(
          'px-4 py-3 rounded-2xl text-sm leading-relaxed whitespace-pre-wrap',
          isUser
            ? 'bg-[var(--oc-accent)]/25 border border-[var(--oc-accent)]/30 text-white rounded-tr-sm'
            : 'glass text-white/90 rounded-tl-sm',
          streaming && 'cursor-blink',
        )}>
          {message.content || (streaming ? '' : '...')}
        </div>
      </div>
    </div>
  )
}
